export const environment = {
  production: false,
  envName: "dev",
  applicationName: "Inmar.Healthcare.MasterData",
  applicationApplinkFeature: "UI::MasterDataAppLink",
  applicationDisplayName: "MasterData",
  rootUrl: "https://dev-web-masterdata.healthcare.inmar.com",
  healthcareTopBar: "https://dev-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js",
  auth0: {
    domain: "https://qa-login.healthcare.inmar.com",
    clientId: "ULHgoQ7ogiunc6l7IvFmQbzHuXyZrRpg",
    refreshToken: true,
    scope: "openid profile email",
  },
  authZApiRoot: {
    url: "https://dev-api-authz.healthcare.inmar.com/v1.0",
    audience: "https://dev-api-authz.healthcare.inmar.com",
  },
  masterDataApiRoot: {
    url: "https://dev-api-masterdata.healthcare.inmar.com/v1.0/api",
    audience: "https://dev-api-masterdata.healthcare.inmar.com",
  },
  defaultListLimit: 1000, // for drop down lists, we want to get *all items so let's try this number
  appInsights: {
    instrumentationKey: "",
  },
  PrismEnvironmentAllowedValues: {
    PrismLPARs: ["PRISMDEV"],
    SpectrumSQLInstances: ["NWSWSQLHC006.CLIENT.EXT"],
  },
};
